import toast from 'react-hot-toast'
export const notifySuccess = (message) => toast.success(message)
export const notifyFailed = (message) => toast.error(message)